// extracted by mini-css-extract-plugin
export var checkIcon = "_6-2";
export var heading = "_6-1";
export var panel = "_6-0";